import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import commentsPlaceholder from 'src/assets/icons/no-comments.svg'
import styles from './comments.module.scss'

class Comments extends Component {
    static propTypes = {
        comments: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string.isRequired,
                subtitle: PropTypes.string,
                message: PropTypes.string,
                avatar: PropTypes.string,
            }).isRequired
        ),
    }

    static defaultProps = {
        comments: [],
    }

    state = { newComment: false }

    componentDidUpdate(prevProps) {
        const { comments } = this.props

        if (prevProps.comments.length + 1 === comments.length) {
            this.setState({ newComment: true }, () => {
                // It takes 4 seconds for the comment animation to finish
                setTimeout(() => this.setState({ newComment: false }), 4000)
            })
        }
    }

    _renderComments() {
        const { newComment } = this.state
        const { comments } = this.props

        return comments.map((comment, index) => (
            <div
                key={`${comment.title}-${index}`}
                className={classNames(styles.comment, {
                    [styles.newComment]:
                        index === comments.length - 1 && newComment,
                })}
            >
                <div className={styles.avatar}>{comment.avatar}</div>
                <div>
                    <p className={styles.title}>{comment.title}</p>
                    <p className={styles.subtitle}>{comment.subtitle}</p>
                    <p className={styles.message}>{comment.message}</p>
                </div>
            </div>
        ))
    }

    _renderCommentsPlaceholder() {
        const { placeholderTitle, placeholderSubtitle } = this.props

        return (
            <div className={styles.placeholder}>
                <img src={commentsPlaceholder} alt="no commnets" />
                <p className={styles.placeholderTitle}>{placeholderTitle}</p>
                <p className={styles.placeholderSubtitle}>
                    {placeholderSubtitle}
                </p>
            </div>
        )
    }

    render() {
        const { comments = [] } = this.props

        return comments.length > 0
            ? this._renderComments()
            : this._renderCommentsPlaceholder()
    }
}

export default Comments
